
<section id="slider">
	<ngb-carousel>
		<ng-template ngbSlide>
			<div class="wrapper">
				<img src="../../assets/img/slider.png" alt="Random first slide">
			</div>
			<div class="carousel-caption">
				<!-- <h3>Добро пожаловать на страницу </h3> -->
				<h4>{{regionName}}</h4>
			</div>
		</ng-template>
	</ngb-carousel>
</section>

<!-- Guide -->
<section id="guide" [ngClass]="{block: leadershipList, none: noLeadershipList}">
	<div class="guide-content" *ngIf="leadershipList">
		<div class="container">
			<div class="row mt-3">
				<div class="col-lg-4">
					<span translate class="title">kazakhstan.nav_leaderships</span>
				</div>
				<div class="col">
					<div class="line"></div>
				</div>
			</div>
			<div class="row mt-4">
				<div class="col-lg-6 col-md-6" *ngFor="let item of leadershipList">
					<div class="box1" (click)="redirectGuideItem(item)">
						<div class="row mb-4">
							<div class="col-lg-12">
								<div class="info">
									<div class="row">
										<div class="col-lg-2">
											<img src="../../assets/img/3.png" alt="" style="margin: 20px 0;">
										</div>
										<div class="col-lg-3 portrait">
											<!-- <img src="../../assets/img/44.png" alt=""> -->
											<img class="rounded-circle" src="{{item.image}}" alt="">
											<!-- <img class="rounded-circle" alt="100x100" src="../../assets/img/3335.jpeg" data-holder-rendered="true"> -->

											<!-- <img class="rounded-circle" alt="100x100"
												src="https://mdbootstrap.com/img/Photos/Avatars/img%20(30).jpg" data-holder-rendered="true"> -->
										</div>
										<div class="col-lg-7 guide-title">
											<span>{{item.name}}</span> <br>
											<p>{{item.rank}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- News section -->
<section id="news" [ngClass]="{block: newsList, none: noNewsList}">
	<div *ngIf="newsList" class="news-content">
		<div class="container">
			<div class="row mt-3">
				<div class="col-lg-4">
					<span translate class="title">kazakhstan.nav_news</span>
				</div>
				<div class="col">
					<div class="line"></div>
				</div>
			</div>

			<div class="row mt-4">
				<div class="col-lg-3" *ngFor="let item of newsList">
					<div class="card mb-3" (click)="redirectNewsPage(item)">
						<!-- <img src="../../assets/img/55.png" class="card-img-top" alt="..."> -->
						<img src="{{item.image}}" class="card-img-top" alt="...">
						<div class="card-body">
							<!-- <h5 class="card-title">Card title</h5> -->
							<p class="card-text"><small class="text-muted">Опубликовано {{item.published}}</small></p>
							<p class="card-text">{{item.title}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-12 text-center">
					<nav aria-label="Page navigation example">
						<ul class="pagination justify-content-center">
							<li class="page-item disabled">
								<a class="page-link" href="#" tabindex="-1" aria-disabled="true">Пред</a>
							</li>
							<li class="page-item"><a class="page-link" href="#">1</a></li>
							<li class="page-item"><a class="page-link" href="#">2</a></li>
							<li class="page-item"><a class="page-link" href="#">3</a></li>
							<li class="page-item">
								<a class="page-link" href="#">След</a>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- Champions section -->
<section id="champions" [ngClass]="{block: winnersList, none: noWinnersList}">
	<div *ngIf="winnersList" class="champions-content">
		<div class="container">
			<div class="row mt-3">
				<div class="col-lg-6">
					<span translate class="title">kazakhstan.nav_winners</span>
				</div>
				<div class="col">
					<div class="line"></div>
				</div>
			</div>

			<div class="row mt-4">
				<div class="col-lg-6 col-xl-3 col-md-6" *ngFor="let item of winnersList">
					<div class="card champs" (click)="redirectToWinnersPage(item)">
						<!-- <img src="../../assets/img/kozha.png" class="card-img-top" alt="..."> -->
						<img src="{{item.image}}" alt="">
						<div class="card-body">
							<h5 class="card-title">{{item.name}}</h5>
							<p class="card-text">{{item.degree}}</p>
							<!-- <a href="#" class="btn btn-primary">Go somewhere</a> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- Partners section -->
<section id="partners" [ngClass]="{paddingPartners: winnersList, paddingNoPartners: noWinnersList}">
	<app-partners></app-partners>
</section>

<!-- Contacts section -->
<section id="contacts" style="padding: 30px 0;">
	<div class="contacts-content">
		<div class="container">
			<div class="row">
				<div class="col-lg-3">
					<span translate class="title">kazakhstan.nav_contacts</span>
				</div>
				<div class="col">
					<div class="line"></div>
				</div>
			</div>
			<br>
			<div class="row mt-2">
				<div class="col-lg-4 footer-info" id="contact2" style="padding: 30px;">
					<div class="phone-number">
						<i style="font-size: large;" class="fa fa-phone" aria-hidden="true"></i>
						<span> +7 777 111 11 11</span>
						<br>
						<span>+7 7172 111 11 11</span>
					</div>
					<br>
					<div class="mail">
						<i style="font-size: large;" class="fa fa-envelope" aria-hidden="true"></i>
						<span> 9qq.org</span>
					</div>
					<br>
					<div class="address">
						<i style="font-size: large;" class="fa fa-map-marker" aria-hidden="true"></i>
						<span> г. Нур-Султан</span> <br>
						<span>пр-кт. Кабанбай батыра</span>
					</div>
				</div>

				<div class="col-lg-8">
					<iframe
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2504.2578298429908!2d71.41637861564197!3d51.12215207957365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x424584215569da81%3A0xc13419a4f8439495!2z0JbQmiDQodCw0YDQvNCw0YIsINGD0LsuINCh0LDRg9GA0LDQvSAzLzEsINCd0YPRgC3QodGD0LvRgtCw0L0gMDIwMDAw!5e0!3m2!1sru!2skz!4v1615309419441!5m2!1sru!2skz"
						width="100%" height="320" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
				</div>


			</div>
		</div>
	</div>
</section>

<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta2/dist/js/bootstrap.bundle.min.js"
	integrity="sha384-b5kHyXgcpbZJO/tY9Ul7kGkf1S0CWuKcCD38l8YkeH8z8QjE0GmW1gYU5S9FOnJ0" crossorigin="anonymous"></script>

<script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.6.0/dist/umd/popper.min.js"
	integrity="sha384-KsvD1yqQ1/1+IA7gi3P0tyJcT3vR+NdBTt13hSJ2lnve8agRGXTTyNaBYmCR/Nwi" crossorigin="anonymous"></script>
<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta2/dist/js/bootstrap.min.js"
	integrity="sha384-nsg8ua9HAw1y0W1btsyWgBklPnCUAFLuTMS2G72MMONqmOymq585AcH49TLBQObG" crossorigin="anonymous"></script>
